export const pieChartData = {
  labels: ["Loading...", "Loading...", "Loading...", "Loading..."],
  datasets: [
    {
      label: "Loading...",
      data: [3.5, 7, 4.5, 10],
      borderColor: "black",
      fill: true,
      backgroundColor: "rgb(211, 211, 211)",
      backgroundGradientFrom: "#000",
      backgroundGradientTo: "#000f",
      borderWidth: 1,
    },
  ],
};

export const barChartData = {
  labels: ["Loading...", "Loading...", "Loading..."],
  datasets: [
    {
      label: "Loading...",
      data: [4, 1.5, 3],
      borderColor: "black",
      fill: true,
      backgroundColor: "rgb(211, 211, 211)",
      backgroundGradientFrom: "#000",
      backgroundGradientTo: "#ffffff",
      borderWidth: 1,
    },
  ],
};

export const lineChartData = {
  labels: [
    "Loading... ",
    "Loading... ",
    "Loading... ",
    "Loading... ",
    "Loading... ",
  ],
  datasets: [
    {
      label: "Loading...",
      data: [2, 4, 1, 3, 1],
      borderColor: "black",
      fill: true,
      backgroundColor: "rgb(211, 211, 211)",
      backgroundGradientFrom: "#000",
      backgroundGradientTo: "#ffffff",
      borderWidth: 1,
    },
    {
      label: "Loading...",
      data: [4, 1, 5, 2, 7],
      borderColor: "black",
      fill: true,
      backgroundColor: "rgb(211, 211, 211)",
      backgroundGradientFrom: "#000",
      backgroundGradientTo: "#ffffff",
      borderWidth: 1,
    },
  ],
};
